import { axiosInstance as axios } from "services";

export const cancelPriceChange = async (changeId, body) => {
  const { data } = await axios.post(`/admin/subscription/global-price-change/${changeId}/cancel`, body);
  if (!data.success) throw new Error(data.error?.message || "Failed to cancel price change");
  return data;
};

